import React, { ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider, StyleSheetManager } from 'styled-components';
import stylisRTLPlugin from 'stylis-plugin-rtl';

import { LightTheme, DarkTheme } from './themes';

import 'src/config/i18n';

export interface ThemeProviderProps {
  rtl?: boolean;
  theme?: 'dark' | 'light';
  children?: ReactNode | React.ReactElement[];
}

const ThemeProvider: React.FC<ThemeProviderProps> = (props) => {
  const { children, theme, rtl = false } = props;

  return (
    <StyledThemeProvider
      theme={(outerTheme) => {
        if (!!theme) {
          const selectedTheme = theme === 'dark' ? DarkTheme : LightTheme;
          return { ...selectedTheme, rtl };
        } else {
          return { ...outerTheme, rtl };
        }
      }}
    >
      <StyleSheetManager stylisPlugins={rtl ? [stylisRTLPlugin as any] : []}>
        {children}
      </StyleSheetManager>
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
